import React, {useEffect, useState} from 'react';
import { observer } from "mobx-react";
import {JackpotBetWidgetGradientTextBox} from "../boxes/gradient-text-box/jackpot-bet-widget-gradient-text.box";
import {JackpotBetPrizeContainerBox} from "./boxes/prize-container/jp-bet-prize-container.box";
import {JackpotBetPrizeAmountContainerBox} from "./boxes/prize-amount/jp-bet-prize-amount.box";

interface JackpotBetWidgetPrizeComponentProps {
    amount: string;
    prizeLabel: string;
}

const ComponentBody: React.FC<JackpotBetWidgetPrizeComponentProps> = observer((props) => {

    const [displayedText, setDisplayedText] = useState(props.prizeLabel);
    const [displayedAmount, setDisplayedAmount] = useState(props.amount);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        // Step 1: Fade out current text
        setIsVisible(false);

        const timeout1 = setTimeout(() => {
            // Step 2: Change text AFTER fade-out completes
            setDisplayedText(props.prizeLabel);
            setDisplayedAmount(props.amount);

            // Step 3: Fade in new text
            setIsVisible(true);
        }, 250); // 250ms fade-out duration

        return () => clearTimeout(timeout1);
    }, [props.prizeLabel, props.amount]);

    return (
        <JackpotBetPrizeContainerBox>
            <JackpotBetWidgetGradientTextBox fontSize={"1.6rem"} dontUpperCase={true} className={`${isVisible ? "fade-in" : "fade-out"}`}>
                {displayedText}
            </JackpotBetWidgetGradientTextBox>
            <div>
                <JackpotBetPrizeAmountContainerBox className={`${isVisible ? "fade-in-amount" : "fade-out-amount"}`}>
                    {displayedAmount.length >= 5 ? displayedAmount.slice(0, -3) : displayedAmount}
                </JackpotBetPrizeAmountContainerBox>
                <JackpotBetPrizeAmountContainerBox>
                    {displayedAmount.length >= 5 ? displayedAmount.slice(-3) : ".00"}
                </JackpotBetPrizeAmountContainerBox>
            </div>
        </JackpotBetPrizeContainerBox>
    );
});

export const JackpotBetWidgetPrizeComponent = ComponentBody;